import { Box, Typography } from '@mui/material';
import { DayActivity } from 'types';

interface ActivityChartProps {
  data: DayActivity[];
}

export default function ActivityChart({ data }: ActivityChartProps) {
  const max = Math.max(...data.map((d) => d.count));
  const todayStr = (() => {
    const n = new Date();
    return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, '0')}-${String(n.getDate()).padStart(2, '0')}`;
  })();
  const todayIndex = data.findIndex((d) => d.date === todayStr);

  return (
    <Box
      sx={{
        background: '#FFFFFF',
        border: '1px solid rgba(20,116,255,0.10)',
        boxShadow: '0 2px 16px rgba(20,116,255,0.08), 0 1px 4px rgba(0,0,0,0.03)',
        borderRadius: 'var(--radius-lg)',
        p: 2.5,
        transition: 'box-shadow 0.20s ease',
        '&:hover': { boxShadow: '0 4px 24px rgba(20,116,255,0.12), 0 1px 4px rgba(0,0,0,0.04)' },
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
      }}
    >
      <Typography
        sx={{
          fontSize: 11,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '0.07em',
          color: 'var(--color-text-muted)',
          mb: 2,
        }}
      >
        Активность по дням
      </Typography>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          gap: 1,
          height: 80,
          justifyContent: 'center',
        }}
      >
        {data.map((d, i) => (
          <Box
            key={d.day}
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 0.5,
            }}
          >
            <Typography
              sx={{
                fontSize: 9,
                color: i === todayIndex ? 'var(--color-primary)' : 'var(--color-text-muted)',
                fontWeight: i === todayIndex ? 700 : 400,
              }}
            >
              {d.count}
            </Typography>
            <Box
              sx={{
                width: '100%',
                height: `${(d.count / max) * 68}px`,
                borderRadius: '4px 4px 0 0',
                background:
                  i === todayIndex
                    ? 'linear-gradient(180deg, #3B8BFF 0%, #1474FF 100%)'
                    : 'rgba(20,116,255,0.10)',
                transition: 'background 0.15s',
                cursor: 'pointer',
                '&:hover': {
                  background:
                    i === todayIndex
                      ? 'linear-gradient(180deg, #3B8BFF 0%, #1474FF 100%)'
                      : 'rgba(20,116,255,0.20)',
                },
              }}
            />
            <Typography
              sx={{
                fontSize: 9.5,
                color: i === todayIndex ? 'var(--color-primary)' : 'var(--color-text-muted)',
                fontWeight: i === todayIndex ? 700 : 400,
              }}
            >
              {d.day}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
